import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import { EstatusJSON } from "../../models/EstatusJSON";
import { ViewsAPIService } from "../API/ViewsAPI.service";
import { AssignmentAPIService } from "../API/AsignmentAPI.service";
import { MapHelperService } from "src/services/map-helper.service";
import { PanelInternalLayerService } from "src/app/features/map-features/sections/locations-section/services/Panel-Internal-Layer.service";
import { GeneratedLayerService } from "src/app/features/map-features/sections/locations-section/services/Generated-Layer.service";
import { ToastrService } from "ngx-toastr";
import { NotificationsToastService } from "../Notifications-Toast.service";
import { PanelExternalLayerService } from "src/app/features/map-features/sections/locations-section/services/Panel-External-Layer.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AssignmentService{

  featureCollectionTemplate = {
    type: "FeatureCollection",
    features: []
  };

  featureTemplate = {
    type: "Feature",
    properties: {  },
    geometry: {}
  };

  regionsGeometries: string[]; 
  zonesGeometries: string[];
  clustersGeometries: string[];
  servicesGeometries: string[];

  regionsGeoJsons: any;
  zonesGeoJsons: any;
  clustersGeoJsons: any;
  finishedEngineersGeoJsons: any;
  servicesGeoJsons: any;

  dummyRegionsGeoJson = {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        properties: { id: "cuauhtemoc", name: "Cuauhtémoc" },
        geometry: {
          type: "Polygon",
          coordinates: [[
            [-99.150, 19.435],
            [-99.120, 19.435],
            [-99.120, 19.415],
            [-99.150, 19.415],
            [-99.150, 19.435]
          ]]
        }
      },
      {
        type: "Feature",
        properties: { id: "coyoacan", name: "Coyoacán" },
        geometry: {
          type: "Polygon",
          coordinates: [[
            [-99.180, 19.370],
            [-99.145, 19.370],
            [-99.145, 19.340],
            [-99.180, 19.340],
            [-99.180, 19.370]
          ]]
        }
      },
      {
        type: "Feature",
        properties: { id: "iztapalapa", name: "Iztapalapa" },
        geometry: {
          type: "Polygon",
          coordinates: [[
            [-99.110, 19.390],
            [-99.060, 19.390],
            [-99.060, 19.350],
            [-99.110, 19.350],
            [-99.110, 19.390]
          ]]
        }
      }
    ]
  };
  dummyZonesGeoJson = {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        properties: { id: "zone1" },
        geometry: {
          type: "Polygon",
          coordinates: [[
            [-99.142, 19.432],
            [-99.130, 19.432],
            [-99.130, 19.422],
            [-99.142, 19.422],
            [-99.142, 19.432]
          ]]
        }
      },
      {
        type: "Feature",
        properties: { id: "zone2" },
        geometry: {
          type: "Polygon",
          coordinates: [[
            [-99.170, 19.365],
            [-99.155, 19.365],
            [-99.155, 19.350],
            [-99.170, 19.350],
            [-99.170, 19.365]
          ]]
        }
      },
      {
        type: "Feature",
        properties: { id: "zone3" },
        geometry: {
          type: "Polygon",
          coordinates: [[
            [-99.095, 19.385],
            [-99.075, 19.385],
            [-99.075, 19.365],
            [-99.095, 19.365],
            [-99.095, 19.385]
          ]]
        }
      }
    ]
  };
  dummyClustersGeoJson =   {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        properties: { "id": "1" },
        geometry: {
          type: "Polygon",
          coordinates: [[
            [-99.134523, 19.428000],
            [-99.134559, 19.428172],
            [-99.134662, 19.428318],
            [-99.134817, 19.428416],
            [-99.135000, 19.428450],
            [-99.135183, 19.428416],
            [-99.135338, 19.428318],
            [-99.135441, 19.428172],
            [-99.135478, 19.428000],
            [-99.135441, 19.427828],
            [-99.135338, 19.427682],
            [-99.135183, 19.427584],
            [-99.135000, 19.427550],
            [-99.134817, 19.427584],
            [-99.134662, 19.427682],
            [-99.134559, 19.427828],
            [-99.134523, 19.428000]
          ]]
        }
      },
      {
        type: "Feature",
        properties: { "id": "2" },
        geometry: {
          type: "Polygon",
          coordinates: [[
            [-99.135523, 19.428000],
            [-99.135559, 19.428172],
            [-99.135662, 19.428318],
            [-99.135817, 19.428416],
            [-99.136000, 19.428450],
            [-99.136183, 19.428416],
            [-99.136338, 19.428318],
            [-99.136441, 19.428172],
            [-99.136478, 19.428000],
            [-99.136441, 19.427828],
            [-99.136338, 19.427682],
            [-99.136183, 19.427584],
            [-99.136000, 19.427550],
            [-99.135817, 19.427584],
            [-99.135662, 19.427682],
            [-99.135559, 19.427828],
            [-99.135523, 19.428000]
          ]]
        }
      },
      {
        type: "Feature",
        properties: { "id": "3" },
        geometry: {
          type: "Polygon",
          coordinates: [[
            [-99.159523, 19.358000],
            [-99.159559, 19.358172],
            [-99.159662, 19.358318],
            [-99.159817, 19.358416],
            [-99.160000, 19.358450],
            [-99.160183, 19.358416],
            [-99.160338, 19.358318],
            [-99.160441, 19.358172],
            [-99.160478, 19.358000],
            [-99.160441, 19.357828],
            [-99.160338, 19.357682],
            [-99.160183, 19.357584],
            [-99.160000, 19.357550],
            [-99.159817, 19.357584],
            [-99.159662, 19.357682],
            [-99.159559, 19.357828],
            [-99.159523, 19.358000]
          ]]
        }
      },
      {
        type: "Feature",
        properties: { "id": "4" },
        geometry: {
          type: "Polygon",
          coordinates: [[
            [-99.160523, 19.358000],
            [-99.160559, 19.358172],
            [-99.160662, 19.358318],
            [-99.160817, 19.358416],
            [-99.161000, 19.358450],
            [-99.161183, 19.358416],
            [-99.161338, 19.358318],
            [-99.161441, 19.358172],
            [-99.161478, 19.358000],
            [-99.161441, 19.357828],
            [-99.161338, 19.357682],
            [-99.161183, 19.357584],
            [-99.161000, 19.357550],
            [-99.160817, 19.357584],
            [-99.160662, 19.357682],
            [-99.160559, 19.357828],
            [-99.160523, 19.358000]
          ]]
        }
      },
      {
        type: "Feature",
        properties: { "id": "5" },
        geometry: {
          type: "Polygon",
          coordinates: [[
            [-99.084523, 19.372000],
            [-99.084559, 19.372172],
            [-99.084662, 19.372318],
            [-99.084817, 19.372416],
            [-99.085000, 19.372450],
            [-99.085183, 19.372416],
            [-99.085338, 19.372318],
            [-99.085441, 19.372172],
            [-99.085478, 19.372000],
            [-99.085441, 19.371828],
            [-99.085338, 19.371682],
            [-99.085183, 19.371584],
            [-99.085000, 19.371550],
            [-99.084817, 19.371584],
            [-99.084662, 19.371682],
            [-99.084559, 19.371828],
            [-99.084523, 19.372000]
          ]]
        }
      },
      {
        type: "Feature",
        properties: { "id": "6" },
        geometry: {
          type: "Polygon",
          coordinates: [[
            [-99.085523, 19.372000],
            [-99.085559, 19.372172],
            [-99.085662, 19.372318],
            [-99.085817, 19.372416],
            [-99.086000, 19.372450],
            [-99.086183, 19.372416],
            [-99.086338, 19.372318],
            [-99.086441, 19.372172],
            [-99.086478, 19.372000],
            [-99.086441, 19.371828],
            [-99.086338, 19.371682],
            [-99.086183, 19.371584],
            [-99.086000, 19.371550],
            [-99.085817, 19.371584],
            [-99.085662, 19.371682],
            [-99.085559, 19.371828],
            [-99.085523, 19.372000]
          ]]
        }
      }
    ]
  }
  dummyFinishedEngineersGeoJson = {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        properties: { id: "ing1", name: "Juan Pérez" },
        geometry: { type: "Point", coordinates: [-99.138, 19.425] }
      },
      {
        type: "Feature",
        properties: { id: "ing2", name: "Armando López" },
        geometry: { type: "Point", coordinates: [-99.158, 19.355] }
      }
    ]
  };
  
  public isAssigning$: Subject<boolean> = new Subject<boolean>();
  
  configUrl: string;
  public Result;
  estatus: EstatusJSON;
  constructor(private assignmentService: AssignmentAPIService, 
    private maphelperService: MapHelperService,
    private generatedLayersService: GeneratedLayerService,
    private toastService: NotificationsToastService,
    private externalLayerService: PanelExternalLayerService) {
  }

  SetAssigning(value: boolean) {
    this.isAssigning$.next(value);
  }

  getAssigning(): Observable<boolean> {
    return this.isAssigning$.asObservable();
  }

  setAssignmentGeoJsons() {
    
    if (this.regionsGeometries != null && this.regionsGeometries.length > 0) {
      this.regionsGeoJsons = JSON.parse(JSON.stringify(this.featureCollectionTemplate));
      this.regionsGeometries.forEach(region => {
        const geometry = JSON.parse(region);
        this.featureTemplate.geometry = geometry;
        const feature = JSON.parse(JSON.stringify(this.featureTemplate));
        this.regionsGeoJsons.features.push(feature);
      });
    }else{
      this.regionsGeoJsons = this.dummyRegionsGeoJson;
    }

    if (this.zonesGeometries != null && this.zonesGeometries.length > 0) {
      this.zonesGeoJsons = JSON.parse(JSON.stringify(this.featureCollectionTemplate));
      this.zonesGeometries.forEach(zone => {
        const geometry = JSON.parse(zone);
        this.featureTemplate.geometry = geometry;
        const feature = JSON.parse(JSON.stringify(this.featureTemplate));
        this.zonesGeoJsons.features.push(feature);
      });
    }else{
      this.zonesGeoJsons = this.dummyZonesGeoJson;
    }

    if (this.clustersGeometries != null && this.clustersGeometries.length > 0) {
      this.clustersGeoJsons = JSON.parse(JSON.stringify(this.featureCollectionTemplate));
      this.clustersGeometries.forEach(cluster => {
        const geometry = JSON.parse(cluster);
        this.featureTemplate.geometry = geometry;
        const feature = JSON.parse(JSON.stringify(this.featureTemplate));
        this.clustersGeoJsons.features.push(feature);
      });
    }else{
      this.clustersGeoJsons = this.dummyClustersGeoJson;
    }

    if (this.servicesGeometries != null && this.servicesGeometries.length > 0) {
      this.servicesGeoJsons = JSON.parse(JSON.stringify(this.featureCollectionTemplate));
      this.servicesGeometries.forEach(service => {
        const geometry = JSON.parse(service);
        this.featureTemplate.geometry = geometry;
        const feature = JSON.parse(JSON.stringify(this.featureTemplate));
        this.servicesGeoJsons.features.push(feature);
      });
    }
  }

  async assignmentShow(){
    try{
      this.deleteGeneratedLayers();
      this.maphelperService.InitialFly( this.maphelperService.Lat.toString(), this.maphelperService.Lng.toString(), this.maphelperService.Zoom.toString(), 0 );
      this.externalLayerService.ActivateLayer("Regiones");
      this.maphelperService.MoveLayer("Regiones-layer", "layer-serviceAssignmentRegions");
      this.maphelperService.MoveLayer("layer-locationsGeneral", "layer-serviceAssignmentFinishedEngineer");
    
      this.toastService.showInfoExtended("Localizando ingenieros y servicios", "");
      await this.stopTime(2000);
  
      //primero se va a los puntos del pointSource
      var pointsSource = this.maphelperService.GetSourceByName("pointsSource") as any;
      if(!environment.production) console.log("pointsSource", pointsSource._data);
      // this.maphelperService.FitBounds(pointsSource._data);
  
      this.toastService.showInfoExtended("Obteniendo regiones", "");
      await this.stopTime(4000);
  
      //depues los poligonos de regiones
      this.maphelperService.UpdateLayerGeoJson("serviceAssignmentRegionsSource", this.regionsGeoJsons);
      this.generatedLayersService.createLayer("Asignación", "Regiones", ["serviceAssignmentRegionsSource"], true);
      this.maphelperService.FitBounds(this.regionsGeoJsons);
      var regionFeatures = this.regionsGeoJsons.features;
      for (const feature of regionFeatures) {
        if(!environment.production) console.log("region feature", feature);
        await this.stopTime(2000);
        this.maphelperService.FitBounds(feature.geometry);
      }
  
      await this.stopTime(1000);
      this.maphelperService.FitBounds(this.regionsGeoJsons);
      this.toastService.showInfoExtended("Obteniendo zonas", "");
      await this.stopTime(5000);
  
      //despues los poligonos de zonas
      // this.generatedLayersService.DeactivateLayer("Asignación", "Regiones");
      this.maphelperService.UpdateLayerGeoJson("serviceAssignmentZonesSource", this.zonesGeoJsons);
      this.generatedLayersService.createLayer("Asignación", "Zonas", ["serviceAssignmentZonesSource"], true);
      this.maphelperService.FitBounds(this.zonesGeoJsons);
      var zoneFeatures = this.zonesGeoJsons.features;
      for (const feature of zoneFeatures) {
        if(!environment.production) console.log("zona feature", feature);
        await this.stopTime(2000);
        this.maphelperService.FitBounds(feature.geometry);
      }
  
      await this.stopTime(1000);
      this.maphelperService.FitBounds(this.zonesGeoJsons);

      this.toastService.showInfoExtended("Obteniendo servicios", "");
      await this.stopTime(2000);

      //despues los servicios
      this.maphelperService.UpdateLayerGeoJson("serviceAssignmentFinishedServiceSource", this.servicesGeoJsons);
      this.generatedLayersService.createLayer("Asignación", "Servicios", ["serviceAssignmentFinishedServiceSource"], true);

      await this.stopTime(2000);
  
      this.toastService.showInfoExtended("Obteniendo clusters", "");
      await this.stopTime(3000);
  
      //despues  los puntos de clusters
      // this.generatedLayersService.DeactivateLayer("Asignación", "Zonas");
      this.maphelperService.UpdateLayerGeoJson("serviceAssignmentClustersSource", this.clustersGeoJsons);
      this.generatedLayersService.createLayer("Asignación", "Clusters", ["serviceAssignmentClustersSource"], true);
      this.maphelperService.FitBounds(this.clustersGeoJsons);
  
      this.toastService.showInfoExtended("Comenzando asignación", "");
      await this.stopTime(2000);
  
      //y al final los puntos de ingenieros asignados, después se quitan
      var i = 0;
      for (const element of pointsSource._data.features) {
        const nombre = element.properties._Id as string;
        if( nombre.includes("bandeja")){
          continue;
        }
        if(!environment.production) console.log("engineer element", element);
        await this.stopTime(5000);
        this.maphelperService.FitBounds(element.geometry, 400);
        this.toastService.showInfoExtended("Asignando ingeniero " + nombre, "");
        const geoJson ={
          type: "FeatureCollection",
          features: [element]
        }
        await this.stopTime(1000);
        this.maphelperService.UpdateLayerGeoJson("serviceAssignmentFinishedEngineerSource", geoJson);
  
        i++;
        if(i>=5)
          break;
      }
  
      await this.stopTime(5000);
      // this.maphelperService.FitBounds(pointsSource._data);
      this.generatedLayersService.ActivateLayer("Asignación", "Regiones");
      this.generatedLayersService.ActivateLayer("Asignación", "Zonas");
      this.generatedLayersService.ActivateLayer("Asignación", "Clusters");
      this.maphelperService.FitBounds(this.regionsGeoJsons);
      this.maphelperService.UpdateLayerGeoJson("serviceAssignmentFinishedEngineerSource", this.maphelperService.Empty_GeoJson);
  
      this.SetAssigning(false);
    }catch(ex){
      console.error("Error en assignmentShow", ex);
      this.toastService.showError("Error mostrando asignaciones", "");
      this.SetAssigning(false);
      return;
    }

  }

  deleteGeneratedLayers(){
    this.generatedLayersService.deleteLayer("Asignación", "Regiones");
    this.generatedLayersService.deleteLayer("Asignación", "Zonas");
    this.generatedLayersService.deleteLayer("Asignación", "Clusters");
    this.maphelperService.UpdateLayerGeoJson("serviceAssignmentRegionsSource", this.maphelperService.Empty_GeoJson);
    this.maphelperService.UpdateLayerGeoJson("serviceAssignmentZonesSource", this.maphelperService.Empty_GeoJson);
    this.maphelperService.UpdateLayerGeoJson("serviceAssignmentClustersSource", this.maphelperService.Empty_GeoJson);
    this.maphelperService.UpdateLayerGeoJson("serviceAssignmentFinishedSource", this.maphelperService.Empty_GeoJson);
  }

  private stopTime(miliSeconds: number) {
    return new Promise(resolve => setTimeout(resolve, miliSeconds));
  }

  GetLastCalculateAllEngineersUI(): Observable<EstatusJSON> {
    return this.assignmentService.GetLastCalculateAllEngineersUI();
  }

  
  
}
